export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white py-16 px-6 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16">
          <div>
            <h3 className="text-sm font-bold mb-4 tracking-wider" style={{ fontFamily: 'Montserrat, sans-serif' }}>サイトマップ</h3>
            <div className="h-px bg-white/20 mb-4"></div>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('about')}
                  className="text-sm text-gray-300 hover:text-orange-400 transition-colors cursor-pointer"
                  style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                >
                  自己紹介
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('career')}
                  className="text-sm text-gray-300 hover:text-orange-400 transition-colors cursor-pointer"
                  style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                >
                  経歴
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('vision')}
                  className="text-sm text-gray-300 hover:text-orange-400 transition-colors cursor-pointer"
                  style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                >
                  ビジョン
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('hobbies')}
                  className="text-sm text-gray-300 hover:text-orange-400 transition-colors cursor-pointer"
                  style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                >
                  趣味
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold mb-4 tracking-wider" style={{ fontFamily: 'Montserrat, sans-serif' }}>SNS</h3>
            <div className="h-px bg-white/20 mb-4"></div>
            <ul className="space-y-3">
              <li>
                <a 
                  href="https://www.instagram.com/jasuta_press?igsh=emF6aTlraG12ZW9u&utm_source=qr" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-sm text-gray-300 hover:text-orange-400 transition-colors"
                  style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
                >
                  <i className="ri-instagram-line text-lg"></i>
                  Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-white/10 pt-12">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <div>
              <div className="flex items-center gap-3">
                <img 
                  src="https://public.readdy.ai/ai/img_res/f7956889-8a63-4f73-b0f9-3e470ed815c3.png" 
                  alt="Logo" 
                  className="w-8 h-8 object-contain"
                />
              </div>
            </div>
            
            <div className="text-center md:text-right">
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
